var app = angular.module("leonardo");

var LevelsListController = function($scope, $state, $controller, parentObj, countryObj, ngDialog, LevelService, FilterService) {

  $scope.countryObj = countryObj;
  $scope.parentObj = parentObj;

  $scope.getLevelType = function () {
    if (!$scope.countryObj) return '';
    var label = 'level_';
    var levelType = 1;
    if ($scope.parentObj) {
      levelType += ($scope.parentObj && $scope.parentObj.level_type == 1 && $scope.countryObj.code.toLowerCase() == "ca") ? parseInt($scope.parentObj.level_type + 1) :  parseInt($scope.parentObj.level_type);
    }
    label += levelType + '_label';
    return $scope.countryObj[label] + 's';
  };

  $scope.getEntitiesPromise = function(options) {
    options['country'] = $scope.countryObj.id;
    options['parents'] = $scope.parentObj ? $scope.parentObj.id : null;
    options['level_type'] = $scope.parentObj ? ($scope.countryObj.code.toLowerCase() == "ca" && $scope.parentObj.level_type == 1 ? ($scope.parentObj.level_type + 2) : $scope.parentObj.level_type + 1) : 1;
    options['name'] = FilterService.getFilter('name');
    return LevelService.getlist(options);
  };

  $scope.editLevel = function(level){
    $state.go('countries.levels.edit', {
      country: $scope.countryObj.id,
      parent: $scope.parentObj ? $scope.parentObj.id : null,
      pk: level.id
    });
  };

  $scope.viewLevel = function (level) {
    if (level.level_type <= 3) {
      $state.go('countries.levels', {country: $scope.countryObj.id, parent: level.id});
    }
  };

  $scope.showDeleteLevel = function(level){
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: level,
        type: 'level'
      }
    }).then(function(data){
      LevelService.updateCollection(data, true);
      $scope.loadPage($scope.page);
    });
  };

  $controller('TableFilterController', { $scope: $scope });
  $scope.loadPage(1);

};

app.controller('LevelsListController', ['$scope', '$state', '$controller', 'parentObj', 'countryObj', 'ngDialog',
  'LevelService', 'FilterService', LevelsListController]);